import { GlobalStore } from "../globalStore";

/**
 * Session key: only set after the broker accepts referral terms on the motor create-quote flow.
 * If unset, the agreement modal is shown again on each visit to that page.
 */
export function getMotorReferralAcceptedSessionKey() {
  const id =
    GlobalStore.brokerObj && GlobalStore.brokerObj.Realm_user_id
      ? GlobalStore.brokerObj.Realm_user_id
      : "unknown";
  return `motorReferralAccepted:${id}`;
}
